import api from "../api";

export const fetchWisdomStages = async () => {
  try {
    const response = await api.get(`/api/v1/wisdom/data/stages`);
    return response.data.stages;
  } catch (error) {
    console.error('Error fetching Wisdom Detailed Data:', error);
    throw error;
  }
};

export const fetchWisdomSubjectsOldApi = async () => {
  try {
    const response = await api.get(`/api/v1/wisdom/subjects`);
    return response.data.subjects;
  } catch (error) {
    console.error('Error fetching Wisdom Detailed Data:', error);
    throw error;
  }
};

export const fetchWisdomSubjects = async () => {
  try {
    const response = await api.get(`/api/v1/wisdom/data/subjects`);
    return response.data.subjects;
  } catch (error) {
    console.error('Error fetching Wisdom Detailed Data:', error);
    throw error;
  }
};

export const fetchWisdomCurriculums = async () => {
  try {
    const response = await api.get(`/api/v1/wisdom/data/curriculums`);
    return response.data.curriculums;
  } catch (error) {
    console.error('Error fetching Wisdom Detailed Data:', error);
    throw error;
  }
};

export const fetchWisdomDepartments = async () => {
  try {
    const response = await api.get(`/api/v1/wisdom/data/departments`);
    return response.data.departments;
  } catch (error) {
    console.error('Error fetching Wisdom Detailed Data:', error);
    throw error;
  }
};

// the old api
export const fetchWisdomSpecializations = async () => {
  try {
    const response = await api.get(`/api/v1/wisdom/specializations`);
    return response.data.specializations;
  } catch (error) {
    console.error('Error fetching Wisdom Detailed Data:', error);
    throw error;
  }
};

// the new api
export const fetchWisdomRelatedSpecializations = async () => {
  try {
    const response = await api.get(`/api/v1/wisdom/data/specializations`);
    return response.data?.specializations || [];
  } catch (error) {
    console.error(
      "Error fetching forms:",
      error.response?.data || error.message
    );
    throw error;
  }
};

// Wisdom Related Schools
export const fetchWisdomRelatedSchools = async () => {
  try {
    const response = await api.get(`/api/v1/wisdom/schools`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.schools || [];
  } catch (error) {
    console.error(
      "Error fetching forms:",
      error.response?.schools || error.message
    );
    throw error;
  }
};

export const fetchWisdomForms = async () => {
  try {
    const response = await api.get(`/api/v1/wisdom/forms`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data.forms;
  } catch (error) {
    console.error("Error fetching forms:", error.response?.forms || error.message);
    throw error;
  }
};

// Wisdom Related Schools
export const fetchWisdomRelatedStudents = async () => {
  try {
    const response = await api.get(`/api/v1/wisdom/data/students`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.students || [];
  } catch (error) {
    console.error(
      "Error fetching forms:",
      error.response?.schools || error.message
    );
    throw error;
  }
};

export const fetchWisdomRelatedTeachers = async () => {
  try {
    const response = await api.get(`/api/v1/wisdom/data/teachers`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.teachers || [];
  } catch (error) {
    console.error(
      "Error fetching forms:",
      error.response?.schools || error.message
    );
    throw error;
  }
};

export const fetchWisdomRelatedEmployees = async () => {
  try {
    const response = await api.get(`/api/v1/wisdom/data/employees`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.employees || [];
  } catch (error) {
    console.error(
      "Error fetching forms:",
      error.response?.schools || error.message
    );
    throw error;
  }
};

export const fetchWisdomRelatedClassRooms = async () => {
  try {
    const response = await api.get(`/api/v1/wisdom/data/classrooms`);
    return response?.data?.classrooms || [];
  } catch (error) {
    console.error('Error fetching Wisdom Detailed Data:', error);
    throw error;
  }
}

export const fetchWisdomClasses = async () => {
  try {
    const response = await api.get(`/api/v1/wisdom/data/classes`);
    return response.data.classes;
  } catch (error) {
    console.error('Error fetching Wisdom Detailed Data:', error);
    throw error;
  }
};

export const fetchWisdomRelatedGradebooks = async () => {
  try {
    const response = await api.get(`/api/v1/wisdom/gradebooks`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.gradebooks || [];
  } catch (error) {
    console.error(
      "Error fetching forms:",
      error.response?.schools || error.message
    );
    throw error;
  }
};

export const fetchWisdomGradebookScores = async (id) => {
  try {
    const response = await api.get(`/api/v1/wisdom/data/gradebooks/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.gradebooks || [];
  } catch (error) {
    console.error(
      "Error fetching forms:",
      error.response?.schools || error.message
    );
    throw error;
  }
};

// Wisdom Related Schools
export const fetchWisdomRelatedOrganizations = async () => {
  try {
    const response = await api.get(`/api/v1/wisdom/data/orgs`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.organizations || [];
  } catch (error) {
    console.error(
      "Error fetching forms:",
      error.response?.organizations || error.message
    );
    throw error;
  }
};

// Wisdom Related Schools
export const fetchTeacherEmployeeDepartments = async () => {
  try {
    const response = await api.get(`/api/v1/wisdom/data/employee-teacher-departments`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.departments || [];
  } catch (error) {
    console.error(
      "Error fetching forms:",
      error.response?.departments || error.message
    );
    throw error;
  }
};

// Wisdom Related Teachers Dashboard
export const fetchWisdomTeachersDashboard = async (orgId, month, year) => {
  try {
    const response = await api.get(`/api/v1/wisdom/data/teachers-dashboard/${year}/${month}/${orgId}`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.dashboard || [];
  } catch (error) {
    console.error(
      "Error fetching forms:",
      error.response?.departments || error.message
    );
    throw error;
  }
};

// Wisdom Related Curriculums Dashboard
export const fetchWisdomCurriculumsDashboard = async (orgId, year, month) => {
  try {
    const response = await api.get(`/api/v1/wisdom/data/curriculums-dashboard/${year}/${month}/${orgId}`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.dashboard || [];
  } catch (error) {
    console.error(
      "Error fetching forms:",
      error.response?.departments || error.message
    );
    throw error;
  }
};

// Wisdom Related WCP Dashboard
export const fetchWisdomWCPDashboard = async (orgId, year, month) => {
  try {
    const response = await api.get(`/api/v1/wisdom/data/WCP-dashboard/${year}/${month}/${orgId}`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.dashboard || [];
  } catch (error) {
    console.error(
      "Error fetching forms:",
      error.response?.departments || error.message
    );
    throw error;
  }
};

// Wisdom Related Work Environment Dashboard
export const fetchWisdomWorkEnvDashboard = async (orgId, year, month) => {
  try {
    const response = await api.get(`/api/v1/wisdom/data/work-environment-dashboard/${year}/${month}/${orgId}`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.dashboard || [];
  } catch (error) {
    console.error(
      "Error fetching forms:",
      error.response?.departments || error.message
    );
    throw error;
  }
};

// Wisdom Related Educational Environment Dashboard
export const fetchWisdomEduEnvDashboard = async (orgId, year, month) => {
  try {
    const response = await api.get(`/api/v1/wisdom/data/educational-environment-dashboard/${year}/${month}/${orgId}`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.dashboard || [];
  } catch (error) {
    console.error(
      "Error fetching forms:",
      error.response?.departments || error.message
    );
    throw error;
  }
};

// Wisdom Related ODBM Dashboard
export const fetchWisdomODBMDashboard = async (orgId, year, month) => {
  try {
    const response = await api.get(`/api/v1/wisdom/data/ODBM-dashboard/${year}/${month}/${orgId}`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.dashboard || [];
  } catch (error) {
    console.error(
      "Error fetching forms:",
      error.response?.departments || error.message
    );
    throw error;
  }
};

// Wisdom Related ClassRoom Uploads
export const fetchWisdomClassRoomUploads = async (classroom_id) => {
  try {
    const response = await api.get(`/api/v1/wisdom/data/classrooms-uploads/${classroom_id}`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.uploads || [];
  } catch (error) {
    console.error(
      "Error fetching forms:",
      error.response?.uploads || error.message
    );
    throw error;
  }
};

// Wisdom Related User Image
export const fetchWisdomUserImage = async (user_id) => {
  try {
    const response = await api.get(`/api/v1/wisdom/data/user-image/${user_id}`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.image || [];
  } catch (error) {
    console.error(
      "Error fetching forms:",
      error.response?.image || error.message
    );
    throw error;
  }
};

// Wisdom Related User Image
export const fetchWisdomTeacherClasses = async (teacher_id) => {
  try {
    const response = await api.get(`/api/v1/wisdom/data/teacher-classes/${teacher_id}`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.classes || response.data?.teacher_classes || [];
  } catch (error) {
    console.error(
      "Error fetching forms:",
      error.response?.image || error.message
    );
    throw error;
  }
};